import { graphql } from "gatsby"
import React from "react"

import SideList from "@knowit-alma/common/src/components/molecules/SideList/SideList"

const SideListBlock = ({ blockDataSideList }) => {
  const { heading, links } = blockDataSideList || {}
  return <SideList heading={heading} links={links} />
}

export const query = graphql`
  fragment SideList on WpBlockAcfSideList {
    __typename
    blockDataSideList {
      heading
      links {
        link {
          target
          title
          url
        }
      }
    }
  }
`

export default SideListBlock
